


import axios from "axios";


const BASE_URL =
    process.env.REACT_APP_API_URL;

export const createCampaign = async (payload, file) => {
    const token = localStorage.getItem("authToken");

    if (!token) throw new Error("Auth token missing — please login again");

    const form = new FormData();

    const jsonBlob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    form.append("campaign", jsonBlob, "campaign.json");

    // ✅ File is optional — only append if provided
    if (file) {
        form.append("creative", file, file.name);
    }



    const response = await axios.post(`${BASE_URL}/promotions/api/user/create/campaign`, form, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        onUploadProgress: (e) => {
            // //console.log("📤 Upload progress:", e.loaded, "of", e.total, "bytes");
        }
    });


    return response;
};

export const updateCampaignStatusAPI = async (id, status) => {
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.put(
            `${BASE_URL}/promotions/api/user/campaign/status/${id}`,
            { status: status },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating campaign status:", error);
        throw error;
    }
};

export const getBillingConfig = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) throw new Error("Auth token missing");

    const response = await axios.get(
        `${BASE_URL}/promotions/api/user/get/billing`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};


export const getVendorDetails = async (vendorId) => {
    const token = localStorage.getItem("authToken");

    try {
        const response = await axios.get(
            `${BASE_URL}/subscription/api/admin/get/enquiry/${vendorId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("❌ FULL ERROR:", error);

        if (error.response) {


        } else {
            console.error("❌ Network error / server not reachable");
        }

        throw error;
    }
};

export const getScreens = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) throw new Error("Auth token missing");

    const response = await axios.get(
        `${BASE_URL}/promotions/api/user/screens`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};

export const getPromotionBillingData = async () => {
    try {
        const token = localStorage.getItem("authToken");

        const response = await fetch(
            `${BASE_URL}/promotions/api/user/get/billing`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const rawText = await response.text();

        if (!rawText) {
            throw new Error(
                `Empty response. Status: ${response.status}`
            );
        }

        return JSON.parse(rawText);

    } catch (error) {
        console.error(
            "❌ Error fetching promotion billing:",
            error
        );

        throw error;
    }
};
// ================= CREATE PAYMENT ORDER =================
export const createPaymentOrderAPI = async (
    amount,
    token
) => {
    try {
        const response = await fetch(
            `${BASE_URL}/promotions/api/payments/create-order/user`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    amount,
                    currency: "INR",
                }),
            }
        );

        return await response.json();

    } catch (error) {
        console.error(
            "❌ Error creating payment order:",
            error
        );

        throw error;
    }
};

// ================= CAPTURE PAYMENT =================
export const capturePaymentAPI = async (
    paymentPayload,
    token
) => {
    try {
        const response = await fetch(
            `${BASE_URL}/promotions/api/payments/capture`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(paymentPayload),
            }
        );

        const responseText = await response.text();

        let responseData = null;

        try {
            responseData = responseText
                ? JSON.parse(responseText)
                : null;
        } catch {
            console.warn(
                "⚠️ Capture response not JSON:",
                responseText
            );
        }

        return {
            ok: response.ok,
            status: response.status,
            data: responseData,
        };

    } catch (error) {
        console.error(
            "❌ Error capturing payment:",
            error
        );

        throw error;
    }
};

export const createDigitalScreenCampaignAPI = async ({
    formData,
    vendorMobile,
}) => {
    try {
        const token =
            localStorage.getItem("authToken") ||
            localStorage.getItem("token") ||
            localStorage.getItem("accessToken");

        const vendorId =
            localStorage.getItem("vendorId") || 1;

        const customerId =
            localStorage.getItem("customerId") ||
            String(vendorId) ||
            "ASEEQWE";

        if (!token) {
            throw new Error("Token missing");
        }

        const selectedScreens = (
            formData.placements || []
        )
            .map((p) => Number(p))
            .filter((id) => !isNaN(id));

        if (selectedScreens.length === 0) {
            throw new Error("No screens selected");
        }

        const durationSeconds =
            formData?.durationSeconds ||
            formData?.mediaDurations?.video ||
            formData?.mediaDurations?.image ||
            10;

        const startDate = formData.startDate
            ? new Date(
                formData.startDate
            ).toISOString()
            : new Date().toISOString();

        const endDate = formData.endDate
            ? new Date(
                formData.endDate
            ).toISOString()
            : new Date().toISOString();

        const payload = {
            screenRequest: {
                durationSeconds,
                period: "PER_DAY",
                screenIds: selectedScreens,
            },

            paymentMethod: null,
            gst: 0,
            totalBudget: 0,

            city: formData.city || "HYD",
            mobileNumber:
                vendorMobile || "9999999999",

            resolution: "R_720P",

            startDate,
            endDate,

            subGoal: "BRAND_AWARENESS",
            goal: "BRANDING",
            medium: "DIGITAL",

            appType:
                formData.appTypes?.[0] ||
                "FOOD_AND_BEVERAGES",

            createdAt: new Date().toISOString(),

            campaignName:
                formData.name || "Campaign",

            description:
                formData?.mediaDescriptions?.image ||
                formData?.mediaDescriptions?.video ||
                "Campaign",

            mediaType: formData.videoFile
                ? "VIDEO"
                : "IMAGE",

            customerId: String(customerId),
        };

        const formDataToSend = new FormData();

        formDataToSend.append(
            "campaign",
            new Blob(
                [JSON.stringify(payload)],
                {
                    type: "application/json",
                }
            )
        );

        let file = null;

        try {
            if (formData?.videoFile) {
                const res = await fetch(
                    formData.videoFile
                );

                const blob = await res.blob();

                file = new File(
                    [blob],
                    "creative.mp4",
                    {
                        type:
                            blob.type ||
                            "video/mp4",
                    }
                );
            } else if (
                formData?.images?.length > 0
            ) {
                const res = await fetch(
                    formData.images[0]
                );

                const blob = await res.blob();

                file = new File(
                    [blob],
                    "creative.jpg",
                    {
                        type:
                            blob.type ||
                            "image/jpeg",
                    }
                );
            }
        } catch (err) {
            console.warn(
                "⚠️ File load failed:",
                err.message
            );
        }

        if (file) {
            formDataToSend.append(
                "creative",
                file
            );
        }

        const response = await fetch(
            `${BASE_URL}/promotions/api/user/create/campaign`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formDataToSend,
            }
        );

        const text = await response.text();

        if (!response.ok) {
            throw new Error(text);
        }

        try {
            return JSON.parse(text);
        } catch {
            return { message: text };
        }

    } catch (error) {
        console.error(
            "❌ Error creating digital campaign:",
            error
        );

        throw error;
    }
};

export const getVendorMenuItemsAPI = async () => {
    try {
        const vendorId =
            localStorage.getItem("vendorId");

        const token =
            localStorage.getItem("authToken");

        if (!vendorId || !token) {
            throw new Error(
                "Vendor ID or token missing"
            );
        }

        const response = await fetch(
            `${BASE_URL}/food/api/dish/getbyvendor/${vendorId}`,
            {
                headers: {
                    "Content-Type":
                        "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            throw new Error(
                "Failed to fetch menu"
            );
        }

        const dishData =
            await response.json();

        const dishes = dishData.filter(
            (item) =>
                item.parentId !== 0 &&
                item.parentId !== null
        );

        return dishes.map((dish) => {
            const parent = dishData.find(
                (p) =>
                    p.dishId === dish.parentId
            );

            return {
                id: dish.dishId,
                name: dish.dishName,
                category:
                    parent?.dishName ||
                    "Uncategorized",
                price: dish.price || 0,
                image: dish.dishImage || "",
                tag: dish.tag || "Veg",
                menuStatus:
                    dish.menuStatus || "Enable",
                selected: false,
                discountType: "percentage",
                discountValue: "",
            };
        });

    } catch (error) {
        console.error(
            "❌ Error fetching menu items:",
            error
        );

        throw error;
    }
};


export const getAllCampaignsAPI = async () => {
    try {
        const token =
            localStorage.getItem("authToken");

        const response = await axios.get(
            `${BASE_URL}/promotions/api/admin/all/campaigns`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "❌ Error fetching campaigns:",
            error
        );

        throw error;
    }
};

// ================= GET ALL SCREENS =================
export const getAllScreensAPI = async () => {
    try {
        const token =
            localStorage.getItem("authToken");

        const response = await axios.get(
            `${BASE_URL}/promotions/api/user/screens`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const data = response.data;

        if (Array.isArray(data)) {
            return data;
        }

        if (
            data.data &&
            Array.isArray(data.data)
        ) {
            return data.data;
        }

        if (
            data.screens &&
            Array.isArray(data.screens)
        ) {
            return data.screens;
        }

        if (
            data.content &&
            Array.isArray(data.content)
        ) {
            return data.content;
        }

        return [];

    } catch (error) {
        console.error(
            "❌ Error fetching screens:",
            error
        );

        throw error;
    }
};

// ================= APPROVE / REJECT CAMPAIGN =================
export const updateCampaignApprovalAPI =
    async ({
        campaignId,
        approvalStatus,
        rejectionReason = "",
    }) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const payload = {
                campaignId,
                approvalStatus,
                rejectionReason,
            };

            const response = await axios.put(
                `${BASE_URL}/promotions/api/admin/campaign/approval`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":
                            "application/json",
                    },
                }
            );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error updating campaign approval:",
                error
            );

            throw error;
        }
    };

// ================= DELETE CAMPAIGN =================
export const deleteCampaignAPI = async (
    campaignId
) => {
    try {
        const token =
            localStorage.getItem("authToken");

        const response = await axios.delete(
            `${BASE_URL}/promotions/api/admin/campaign/${campaignId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "❌ Error deleting campaign:",
            error
        );

        throw error;
    }
};

// ================= GET CAMPAIGN BY ID =================
export const getCampaignByIdAPI = async (
    campaignId
) => {
    try {
        const token =
            localStorage.getItem("authToken");

        const response = await axios.get(
            `${BASE_URL}/promotions/api/user/campaign/${campaignId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "❌ Error fetching campaign:",
            error
        );

        throw error;
    }
};

// ================= CREATE CAMPAIGN =================
export const createCampaignAPI = async ({
    formData,
    creativeFile,
    screenIds,
    creativeDuration,
    displayPositionRatios,
}) => {
    try {
        const token =
            localStorage.getItem("authToken");

        if (!token) {
            throw new Error(
                "Session expired. Please login again."
            );
        }

        const customerId =
            formData.customerId ||
            localStorage.getItem(
                "customerId"
            );


        let campaignData;

        if (formData.medium === "DIGITAL") {
            campaignData = {
                screenRequest: {
                    durationSeconds:
                        creativeDuration || 20,
                    period: "PER_DAY",
                    screenIds: screenIds,
                },

                endDate: formData.endDate
                    ? new Date(
                        formData.endDate
                    ).toISOString()
                    : new Date().toISOString(),

                city: formData.city || "",

                startDate: formData.startDate
                    ? new Date(
                        formData.startDate
                    ).toISOString()
                    : new Date().toISOString(),

                status: formData.status,
                goal: formData.goal,
                medium: formData.medium,
                customerId: customerId,

                createdAt:
                    new Date().toISOString(),

                campaignName:
                    formData.campaignName,

                description:
                    formData.description,

                mediaType:
                    formData.mediaType,

                subGoal:
                    formData.subGoal,
            };

        } else {
            const selectedPosition =
                formData.addDisplayPosition;

            const resolution =
                displayPositionRatios[
                    selectedPosition
                ]?.resolution ||
                "R_720P";

            campaignData = {
                campaignName:
                    formData.campaignName,

                description:
                    formData.description,

                subGoal:
                    formData.subGoal,

                goal: formData.goal,

                medium:
                    formData.medium,

                status:
                    formData.status,

                startDate:
                    formData.startDate
                        ? new Date(
                            formData.startDate
                        ).toISOString()
                        : new Date().toISOString(),

                endDate:
                    formData.endDate
                        ? new Date(
                            formData.endDate
                        ).toISOString()
                        : new Date().toISOString(),

                customerId:
                    customerId,

                appType:
                    formData.appType,

                deepLink:
                    formData.deepLink ||
                    "",

                addDisplayPosition:
                    formData.addDisplayPosition,

                resolution:
                    resolution,

                mediaType:
                    formData.mediaType,

                interests:
                    formData.interests,

                city:
                    formData.city ||
                    "",

                centerLatitude:
                    parseFloat(
                        formData.centerLatitude
                    ) || 17.385,

                centerLongitude:
                    parseFloat(
                        formData.centerLongitude
                    ) || 78.4867,

                radiusKm:
                    parseFloat(
                        formData.radiusKm
                    ) || 100,

                paymentStatus:
                    formData.paymentStatus ||
                    "PENDING",

                targetAudience:
                    formData.targetAudience ||
                    ["Users"],

                targeting: {
                    interests:
                        formData.interests,

                    city:
                        formData.city ||
                        "",

                    centerLatitude:
                        parseFloat(
                            formData.centerLatitude
                        ) || 17.385,

                    centerLongitude:
                        parseFloat(
                            formData.centerLongitude
                        ) || 78.4867,

                    radiusKm:
                        parseFloat(
                            formData.radiusKm
                        ) || 100,

                    targetAudience:
                        formData.targetAudience ||
                        ["Users"],
                },

                totalBudget: 0,
                likesCount: 0,
                viewsCount: 0,
                sharesCount: 0,
                savesCount: 0,
                commentsCount: 0,

                createdAt:
                    new Date().toISOString(),

                vendorId: 0,
                dishId: 0,
                discountPercentage: 0,
                calculatedAmount: 0,

                approvalStatus:
                    "PENDING",
            };
        }

        const fd = new FormData();

        fd.append(
            "campaign",
            new Blob(
                [JSON.stringify(campaignData)],
                {
                    type: "application/json",
                }
            )
        );

        if (creativeFile) {
            fd.append(
                "creative",
                creativeFile,
                creativeFile.name
            );
        } else {
            fd.append(
                "creative",
                new Blob([]),
                ""
            );
        }

        const response = await axios.post(
            `${BASE_URL}/promotions/api/user/create/campaign`,
            fd,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":
                        "multipart/form-data",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "❌ Error creating campaign:",
            error
        );

        throw error;
    }
};

// ================= GET CAMPAIGN ANALYTICS SUMMARY =================
export const getCampaignAnalyticsSummaryAPI =
    async (fromDate, toDate) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response = await axios.get(
                `${BASE_URL}/promotions/api/admin/campaigns/analytics`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },

                    params: {
                        fromDate,
                        toDate,
                    },
                }
            );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error fetching summary analytics:",
                error
            );

            throw error;
        }
    };

// ================= GET SINGLE CAMPAIGN ANALYTICS =================
export const getCampaignAnalyticsAPI =
    async (campaignId) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response = await axios.get(
                `${BASE_URL}/promotions/api/user/campaigns/${campaignId}/stats`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return response.data;

        } catch (error) {
            console.error(
                "❌ Error fetching campaign analytics:",
                error
            );

            throw error;
        }
    };

// ================= GET SCREENS WITH DATA =================
export const getScreensWithDataAPI =
    async (getAuthToken) => {
        try {
            const token =
                getAuthToken();

            if (!token) {
                throw new Error(
                    "No authentication token found. Please ensure you are logged in."
                );
            }

            const response = await fetch(
                `${BASE_URL}/promotions/api/user/screens-with-data`,
                {
                    method: "GET",

                    headers: {
                        Authorization: `Bearer ${token}`,

                        "Content-Type":
                            "application/json",

                        Accept:
                            "application/json",
                    },
                }
            );

            if (response.status === 401) {
                throw new Error(
                    "Session expired. Please login again."
                );
            }

            if (response.status === 403) {
                throw new Error(
                    "Access denied. You don't have permission to view screens."
                );
            }

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status}`
                );
            }

            return await response.json();

        } catch (error) {
            console.error(
                "❌ Error fetching screens data:",
                error
            );

            throw error;
        }
    };

// ================= GET ALL SCREENS =================
export const getScreensAPI = async (
    getHeaders
) => {
    try {
        const response = await fetch(
            `${BASE_URL}/promotions/api/user/screens`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.status === 401) {
            throw new Error(
                "Unauthorized. Please log in again."
            );
        }

        if (response.status === 403) {
            throw new Error(
                "Access forbidden. You do not have permission to view screens."
            );
        }

        if (!response.ok) {
            throw new Error(
                `HTTP error! status: ${response.status}`
            );
        }

        const data =
            await response.json();

        return Array.isArray(data)
            ? data
            : [];

    } catch (error) {
        console.error(
            "Error fetching screens:",
            error
        );

        throw error;
    }
};


export const getVendors = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) throw new Error("Auth token missing — please login again");

    //console.log("📡 Calling getVendors → GET /food/api/vendors/getall");

    const response = await fetch(`${BASE_URL}/food/api/vendors/getall`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    //console.log("📥 getVendors response status:", response.status, response.statusText);

    if (!response.ok) {
        const errorText = await response.text();

        throw new Error(`Failed to fetch vendors: ${response.status}`);
    }

    const data = await response.json();

    return data;
};


// ================= SAVE / UPDATE SCREEN =================
export const saveOrUpdateScreenAPI =
    async ({
        screenData,
        action,
        getHeaders,
    }) => {
        try {
            let url =
                `${BASE_URL}/promotions/api/admin/add-screen`;

            let method = "POST";

            if (action === "update") {
                url =
                    `${BASE_URL}/promotions/api/admin/screens/update-screen`;

                method = "PUT";
            }

            const response = await fetch(
                url,
                {
                    method,
                    headers:
                        getHeaders(),
                    credentials:
                        "include",

                    body: JSON.stringify(
                        screenData
                    ),
                }
            );

            if (response.status === 401) {
                throw new Error(
                    "Unauthorized. Please log in again."
                );
            }

            if (response.status === 403) {
                throw new Error(
                    "Access forbidden. You do not have permission to perform this action."
                );
            }

            if (!response.ok) {
                const errorText =
                    await response.text();

                console.error(
                    "Server error response:",
                    errorText
                );

                throw new Error(
                    `HTTP error! status: ${response.status}`
                );
            }

            if (action === "update") {
                return screenData;
            }

            return await response.json();

        } catch (error) {
            console.error(
                `Error ${action}ing screen:`,
                error
            );

            throw error;
        }
    };

// ================= RESET SCREEN PASSWORD =================
export const resetScreenPasswordAPI =
    async ({
        deviceId,
        newPassword,
        getHeaders,
    }) => {
        try {
            const url =
                `${BASE_URL}/promotions/api / admin / screen / forget - password ? deviceId = ${deviceId}& newPassword=${encodeURIComponent(newPassword)} `;

            const response = await fetch(
                url,
                {
                    method: "PUT",

                    headers:
                        getHeaders(false),

                    credentials:
                        "include",
                }
            );

            if (response.status === 401) {
                throw new Error(
                    "Unauthorized. Please log in again."
                );
            }

            if (response.status === 403) {
                throw new Error(
                    "Access forbidden. You do not have permission to reset passwords."
                );
            }

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status} `
                );
            }

            return true;

        } catch (error) {
            console.error(
                "Error resetting password:",
                error
            );

            throw error;
        }
    };

// ================= DELETE SCREEN =================
export const deleteScreenAPI =
    async ({
        deviceId,
        getHeaders,
    }) => {
        try {
            const url =
                `${BASE_URL}/promotions/api / admin / screens / delete -screen / ${deviceId}?deviceId = ${deviceId} `;

            const response = await fetch(
                url,
                {
                    method: "DELETE",

                    headers:
                        getHeaders(false),

                    credentials:
                        "include",
                }
            );

            if (response.status === 401) {
                throw new Error(
                    "Unauthorized. Please log in again."
                );
            }

            if (response.status === 403) {
                throw new Error(
                    "Access forbidden. You do not have permission to delete screens."
                );
            }

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status} `
                );
            }

            return true;

        } catch (error) {
            console.error(
                "Error deleting screen:",
                error
            );

            throw error;
        }
    };



